module.exports = __webpack_public_path__ + "img/jyen.0e075590.png";